<template>

    <div class="modal__overlay">

        <div class="modal-contentShare">
            <h4>{{ $t('contentShare.EDIT_PRACTICE_WITH_STUDENTS') }}</h4>
            <div class="select-activity">
                <div>
                    <div>
                        <h4>{{ $t('contentShare.ACTIVITY') }} {{ selected.activity }}</h4>
                        <button
                            v-if="content?.data?.Subcontents.length === 1"
                            @click="activateSecondActivity()"
                            :class="{ disabled: isPublished }"
                        >
                            <i class="material-icons icon-button">add_circle</i>
                        </button>
                        <button
                            v-if="selected.activity === 2 && content?.data?.Subcontents.length === 2"
                            @click="desctivateSecondActivity()"
                            :class="{ disabled: isPublished }"
                        >
                            <i class="material-icons icon-button remove">delete</i>
                        </button>
                    </div>
                </div>
                
                <div>
                    <h4><strong>{{`0${selected.activity} / `}}</strong>{{ content?.data?.Subcontents.length === 1 ? '01' : '02' }}</h4>
                    <span>
                        <i class="material-icons" @click="changeSelected(1,'teacher')"
                        :style="`${selected.activity == 1 ? 'opacity:.3' : ''}`"
                        :class="{ disabled: selected.activity === 1 }"
                        >
                            arrow_back
                        </i>
                        <i class="material-icons" @click="content?.data?.Subcontents.length === 1 || selected.activity === 2 ? '' : changeSelected(2,'teacher')"
                        :style="`${selected.activity == 2 ? 'opacity:.3' : '' || content?.data?.Subcontents.length === 1 ? 'opacity:.3' : ''}`"
                        :class="{ disabled: content?.data?.Subcontents.length === 1 || selected.activity === 2 }"
                        >
                            arrow_forward
                        </i>
                    </span>
                </div>
            </div>


            
            

            <h5>{{ $t('contentShare.ACTIVITY_COVER') }}</h5>

            <div
            :style="`display: ${selected.activity == 1 ? 'block' : 'none'}`"
            >
                <UploadFileDrag
                    v-if="selected.activity == 1"
                    :currentFile="props.content.data.Subcontents[0].ImagePreview"
                    containerCDN="content"
                    @fileUploaded="fileCDN => fileUploaded(fileCDN)"
                    @fileDeleted="deleteImagePreview()"
                />
            </div>
            

            <div
            :style="`display: ${selected.activity == 2 ? 'block' : 'none'}`"
            >
                <UploadFileDrag
                    v-if="selected.activity == 2"
                    :currentFile="computedCurrentFile"
                    containerCDN="content"
                    @fileUploaded="fileCDN => fileUploaded(fileCDN)"
                    @fileDeleted="deleteImagePreview()"
                />
            </div>

            
            <div class="hide-shared-tab-toggle">
                <div
                v-if="selected.activity == 1"
                >
                <span>{{ $t('contentShare.HIDE_STUDENT_TAB') }}</span>
                <div
                        :class="{ active: hideFirstSharedTab }"
                        class="toggle-button"
                        @click="toggleFirstSharedTab()"
                    >
                        <div class="toggle-handle"></div>
                    </div>
                </div>
                <div
                v-else
                >
                    <span>{{ $t('contentShare.HIDE_STUDENT_TAB') }}</span>
                    <div
                        :class="{ active: hideSecondSharedTab }"
                        class="toggle-button"
                        @click="toggleSecondSharedTab()"
                    >
                        <div class="toggle-handle"></div>
                    </div>
                </div>
            </div>

            <div class="content-for">
                <span :class="{'--selected' : selected.contentFor == 'teacher'}" @click="changeSelected(null,'teacher')">{{$t('finalPractice.TEACHER_TITLE')}}</span>
                <span :class="{'--selected' : selected.contentFor == 'student'}" @click="changeSelected(null,'student')">{{$t('finalPractice.STUDENT_TITLE')}}</span>                

            </div>



            <Input
                @input="checkIfAllFieldsAreFilled()"
                type="text"
                id="contentShareLink"
                :placeholder="$t('contentShare.LINK')"
                v-model="geniallyURL"
                :label="$t('contentShare.LINK')"
            />


            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                <button
                    class="confirm"
                    @click.stop="save()" 
                    :disabled="isSaveDisabled"
                >
                {{ $t('global.SAVE') }}<i class="material-icons">arrow_forward</i>
                </button>
            </div>

        </div>

    </div>

    
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, watch, computed } from 'vue';
import { useStore } from 'vuex';
import Input from '@/components/Input.vue';
import UploadFileDrag from '@/components/UploadFileDrag.vue';
import { useI18n } from 'vue-i18n';


const { t } = useI18n();


const store = useStore();
const saving = ref(false);

const props = defineProps({
    content: Object,
    isPublished: Boolean
});
const emit = defineEmits(['close','reload']);

const selected = ref({
    activity: 1,
    contentFor: 'teacher'
})

const content = ref();
const isPublished = ref();

const geniallyURL = ref('');

const geniallyLacking = ref(false);



const isSaveDisabled = computed(() => {
    return geniallyLacking.value || saving.value || (content?.value?.data?.Subcontents.length === 1 ? !content?.value?.data?.Subcontents[0].ImagePreview : !content?.value?.data?.Subcontents[0].ImagePreview || !content?.value?.data?.Subcontents[1].ImagePreview);
});

const checkIfAllFieldsAreFilled = () => {
    geniallyLacking.value = !geniallyURL.value.trim();

}

const hideFirstSharedTab = ref(false);
const hideSecondSharedTab = ref(false);

const toggleFirstSharedTab = () => {
    const currentSubcontent = content.value.data.Subcontents[0];
    currentSubcontent.hideSharedTab = !currentSubcontent.hideSharedTab;
    hideFirstSharedTab.value = currentSubcontent.hideSharedTab;
};
const toggleSecondSharedTab = () => {
    const currentSubcontent = content.value.data.Subcontents[1];
    currentSubcontent.hideSharedTab = !currentSubcontent.hideSharedTab;
    hideSecondSharedTab.value = currentSubcontent.hideSharedTab;
};







const isSecondActivityEnabled = ref(false);



const computedCurrentFile = computed(() => {
  if (selected.value.activity === 2) {
    return content.value?.data?.Subcontents[1]?.ImagePreview || '';
  }
  return content.value?.data?.Subcontents[0]?.ImagePreview;
});

const desctivateSecondActivity = ()=>{
    content.value.data.Subcontents.splice(1,1);

    isSecondActivityEnabled.value = false;

    selected.value.activity = 1;
    showData();
}


const activateSecondActivity = () => {
    if (!content.value.data.Subcontents[1]) {
        const newActivity = {
            OwnTab: '',
            SharedTab: '',
            ImagePreview: ''
        };
        content.value.data.Subcontents.push(newActivity);
        selected.value.activity = 2;
    }
    isSecondActivityEnabled.value = true;

    showData();
}


const getGeniallyUrl = (container)=>{
    let $div = document.createElement('div');
    $div.innerHTML = container;
    let $iframe = $div.querySelector('iframe');
    let src = $iframe.getAttribute('src');
    geniallyURL.value = src;
}

const showData = ()=>{
    let cont;
    if(selected.value.activity == 1 && selected.value.contentFor == 'teacher'){
        cont = content.value.data.Subcontents[0].OwnTab;
    }
    else if(selected.value.activity == 1 && selected.value.contentFor == 'student'){
        cont = content.value.data.Subcontents[0].SharedTab;
    }
    else if(selected.value.activity == 2 && selected.value.contentFor == 'teacher'){
        cont = isSecondActivityEnabled.value ? content.value.data.Subcontents[1].OwnTab : '';
    }
    else if(selected.value.activity == 2 && selected.value.contentFor == 'student'){
        cont = isSecondActivityEnabled.value ? content.value.data.Subcontents[1].SharedTab : '';
    }
    if(cont){
        getGeniallyUrl(cont);
    } else {
        geniallyURL.value = '';
    }
}

const setData = ()=>{
    let genially = `<div style="width: 100%;"><div class="genially-container" style="position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;"><iframe frameborder="0" width="1200" height="675" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="${geniallyURL.value}" type="text/html" allowscriptaccess="always" allowfullscreen="true" scrolling="yes" allownetworking="all"></iframe> </div></div>` 

    if(selected.value.activity == 1 && selected.value.contentFor == 'teacher'){
        content.value.data.Subcontents[0].OwnTab = genially;
    }
    else if(selected.value.activity == 1 && selected.value.contentFor == 'student'){
        content.value.data.Subcontents[0].SharedTab = genially;
    }
    else if(selected.value.activity == 2 && selected.value.contentFor == 'teacher'){
        if(content.value.data.Subcontents[1]){
            content.value.data.Subcontents[1].OwnTab = genially;
        } else {
            genially = '';
        }
    }
    else if(selected.value.activity == 2 && selected.value.contentFor == 'student'){
        console.log(genially)
        if(content.value.data.Subcontents[1]){
            content.value.data.Subcontents[1].SharedTab = genially;
        } else {
            genially = '';
        }
    }

}

const changeSelected = (activity=null,contentFor=null)=>{
    setData();
    if(activity) selected.value.activity = activity;
    if(contentFor) selected.value.contentFor =  contentFor;
    showData();
}

const fileUploaded = (fileCDN)=>{
    content.value.data.Subcontents[selected.value.activity-1].ImagePreview = fileCDN;
    checkIfAllFieldsAreFilled();
}

const deleteImagePreview = ()=>{
    content.value.data.Subcontents[selected.value.activity-1].ImagePreview = '';
}


const save = async () => { 
    setData();
    saving.value = true;
    try {
        if(content.value.data.Subcontents[0]){
            content.value.data.Subcontents[0].hideSharedTab = hideFirstSharedTab.value;
        }
        if(content.value.data.Subcontents[1]){
            content.value.data.Subcontents[1].hideSharedTab = hideSecondSharedTab.value;
        }
        content.value.data.Subcontents = JSON.stringify(content.value.data.Subcontents);
        await store.dispatch('contentEditor_editContent', content.value)
        emit('reload');        
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: t('contentShare.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}

onMounted(() => {
    content.value = props.content;
    isPublished.value = props.isPublished;

    hideFirstSharedTab.value = content.value.data.Subcontents[0].hideSharedTab;
    if(content.value.data.Subcontents[1]){
        hideSecondSharedTab.value = content.value.data.Subcontents[1].hideSharedTab;
    }
    
    showData()

    if(content.value.data.Subcontents.length === 2){
        isSecondActivityEnabled.value = true;
    }

    
})

watch(() => props.content, (newVal) => {
    content.value = newVal;
}, { deep: true });
    
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';


.modal-contentShare{
    @include componentModal;
    display: flex;
    flex-direction: column;
    gap: 22px;
    h5{
        margin-bottom: -8px;
    }
    .select-activity{
        display: flex;
        justify-content: space-between;
        align-items: center;
        div,span{
            display: flex;
            gap: 16px;
            h4{
                font-weight: 500;
            }
            .material-icons{
                cursor: pointer;
            }
            .icon-button {
                color: $green;
                &.remove {
                    color: $red;
                }
            }
        }

        .select-activity__toggle {
            display: flex;
            align-items: center;
        }

    }
    .content-for{
        display: flex;
        align-items: center;
        gap: 22px;
        span{
            font-size: 14px;
            font-weight: 600;
            padding: 8px 24px 8px 8px;
            margin: 0 6px;
            cursor: pointer;
            &.--selected{
                color: $green;
                border-bottom: 3px solid $green;
            }
        }
    }

    .hide-shared-tab-toggle {
        > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 16px;
        }
        span {
            font-size: 14px;
            font-weight: 600;
        }
    
    }

}

.disabled{
    opacity: .3;
    cursor: default;
    pointer-events: none;
}

</style>